import type { FocusEventHandler } from "react";
import { IMaskInput } from "react-imask";

interface CepInputProps {
	id?: string;
	value: string;
	onAccept: (value: string) => void;
	onBlur?: FocusEventHandler<HTMLInputElement>;
	"aria-invalid"?: boolean;
}

// CepInput is the masked CEP field (00000-000). It borrows the Input primitive's
// look via data-slot="input" and keeps the dash in the stored value (the address
// schema accepts both forms). Built on react-imask — the same mask library the
// DatePicker uses.
export function CepInput({ value, onAccept, ...rest }: CepInputProps) {
	return (
		<IMaskInput
			{...rest}
			data-slot="input"
			mask="00000-000"
			value={value}
			inputMode="numeric"
			placeholder="00000-000"
			onAccept={(next: string) => onAccept(next)}
		/>
	);
}
